// extracted by mini-css-extract-plugin
export default {"containerNoData":"CustomNoData_containerNoData__KtoJa","title":"CustomNoData_title__myVlF"};